<template>
  <div class="content__item content__item--grid grid" :class="{ container: gridType === 'grid' }">
    <Row v-for="row in rows" :key="row.state.modelId" :model="row" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { ContentGrid } from '@/components/layout/section/SectionBaseModel';
import Row from '@/components/layout/row/Row.vue';
import { GridTypes } from '@/typings/types/types';

export default defineComponent({
  name: 'Grid',
  components: {
    Row
  },
  props: {
    content: {
      type: Object as PropType<ContentGrid>,
      required: true
    },
    sectionIndex: Number,
    sectionId: Number,
    gridType: {
      type: String as PropType<GridTypes>,
      default: 'grid'
    }
  },
  setup(props) {
    const rows = computed(() => {
      return props.content.rows.filter((content) => {
        const visibilityConditions = content.state.settings?.state?.advanced?.visibilityCondition;

        return visibilityConditions ? visibilityConditions.check() : true;
      });
    });

    return {
      rows
    };
  }
});
</script>

<style lang="scss">
.content__item--grid.grid {
  display: flex;
  flex-direction: column;
}
</style>
